
<template>
  <div>
    <!-- <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin> -->
    <v-main>
      <div class="pl-12 pr-12 col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-row>
          <v-col cols="6" class="text-left">
            <v-breadcrumbs :items="breadcrumbs" id="v-step-4"></v-breadcrumbs>
          </v-col>
          <v-col cols="6" class="v-margit_button text-right">
            <v-btn
              color="#1B437C"
              id="v-step-0"
              depressed
              dark
              @click=";(dialogAdd = true), validate('ADD')"
            >
              <v-icon left>mdi-text-box-plus</v-icon>
              เพิ่ม
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-dialog v-model="dialogAddReward" width="650">
            <v-expansion-panels
              v-model="panel"
              multiple
            >
              <v-expansion-panel>
                <v-expansion-panel-header style="background-color: rgb(27, 67, 124);color: white;font-weight: 100 !important;" disable-icon-rotate>
                  ของรางวัลเมื่อสมาชิกเลื่อนระดับ
                  <template v-slot:actions>
                    <v-icon style="color: white !important;" class="iconify" data-icon="fluent:gift-card-add-20-filled"></v-icon>
                    <iconify-icon icon="fluent:gift-card-add-20-filled"></iconify-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content style="padding: 2px; padding-top: 10px;">
                  <p style="text-align: center;color: darkorange;">**เพิ่มหรือไม่เพิ่มก็ได้**</p>
                  <div>
                    <v-row style="display: flex;justify-content:space-between">
                      <v-col cols="12" sm="6" md="12" xs="12">
                          <p class="mb-5" style="text-align: center;">รูปของรางวัล</p>
                          <div style="justify-content: center;display: flex;">
                            <v-card
                              @click="chooseImage"
                              class="image-input"
                              :style="{
                                'background-image': `url(${dataFormAddReward.pictureUrlPreview})`,
                                'background-size': 'contain',
                                'background-position': 'center center',
                                'background-repeat': 'no-repeat',
                                'justify-content': 'center',
                                'align-items': 'center',
                                'display': 'flex'
                              }"
                            >
                              <span
                                v-if="dataFormAddReward.pictureUrlPreview === '' || dataFormAddReward.pictureUrlPreview === null"
                              >
                                <v-icon class="iconify" size="54" data-icon="icon-park:add-picture"></v-icon>
                                <div>กดเพื่อเลือกรูปของรางวัล</div>
                              </span>
                              <input
                                style="display: none"
                                class="file-input"
                                ref="fileInput"
                                type="file"
                                @input="onSelectFile"
                              />
                            </v-card>
                          </div>
                      </v-col>
                      <v-col cols="12" sm="12" md="12" xs="12">
                        <p class="mb-3" style="text-align: center;">ข้อมูลของรางวัล</p>
                        <v-text-field
                          label="ชื่อของรางวัล"
                          outlined
                          dense
                        ></v-text-field>
                        <v-text-field
                          label="จำนวนที่ต้องการแจก"
                          outlined
                          dense
                        ></v-text-field>
                        <!-- <v-select
                          :items="itemsDate"
                          label="วันหมดอายุหลังจากได้รับ"
                          outlined
                          dense
                        ></v-select> -->
                        <v-radio-group v-model="dataFormAddReward.expireType" row>
                        <v-radio
                          label="กำหนดวันหมดอายุ"
                          value="FixDate"
                          color="#6683d3"
                        ></v-radio>
                        <v-radio
                          label="หมดอายุหลังจากวันที่แลกของรางวัล"
                          value="Redeem"
                          color="#6683d3"
                        ></v-radio>
                      </v-radio-group>
                      <VuetifyMoney
                        v-if="dataFormAddReward.expireType == 'Redeem'"
                        v-model="dataFormAddReward.countExpire"
                        label="จำนวนวัน"
                        outlined
                        dense
                        required
                        :rules="[rules.required]"
                        v-bind:options="options2"
                      />
                      <v-row
                        v-if="dataFormAddReward.expireType == 'FixDate'"
                        style="padding: 0px 16px"
                      >
                        <v-col cols="6" style="padding: 12px 0px 0px">
                          <v-menu
                            v-model="menu2"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="dataFormAddReward.endDate"
                                label="วันหมดอายุ"
                                outlined
                                dense
                                v-bind="attrs"
                                v-on="on"
                                :rules="[rules.required]"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              :min="new Date().toISOString().substr(0, 10)"
                              v-model="dataFormAddReward.endDate"
                              @input="menu2 = false"
                            >
                            </v-date-picker>
                          </v-menu>
                        </v-col>
                      </v-row>
                      </v-col>
                    </v-row>
                  </div>
                  <div class="mt-3">
                    <v-btn block color="rgb(28 67 124 / 78%)" style="color: white !important;" @click="addReward"><v-icon>mdi-plus</v-icon>เพิ่มรางวัล</v-btn>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-dialog>
          <v-dialog v-model="dialogAdd" persistent :max-width= "resCol === '12' ? '' : '40%'" :fullscreen="resCol === '12' ? true : false">
            <v-card>
              <v-form ref="form_add" v-model="validAdd" lazy-validation>
                <v-card-text>
                  <v-container>
                    <v-col class="text-right">
                      <v-btn
                        small
                        color="#E0E0E0"
                        @click=";(dialogAdd = false), clearDataAdd()"
                      >
                        <v-icon color="#173053">mdi-close</v-icon>
                      </v-btn>
                    </v-col>
                    <v-row justify="center">
                      <!-- <v-col cols="5" class="text-center">
                        <v-col class="text-center">
                          <v-img
                            class="v-margit_img_reward"
                            :src="require('@/assets/GroupLevel.svg')"
                            max-width="330"
                          ></v-img>
                        </v-col>
                      </v-col> -->

                      <v-col cols="12" >
                        <!-- <v-col class="text-center">
                          <v-img
                            class="v_text_add"
                            :src="require('@/assets/Grouptitle.svg')"
                          ></v-img>
                        </v-col> -->
                        <v-col style="padding: 15px 16px 0px">
                          <h2>เพิ่มข้อมูลระดับสมาชิก</h2>
                        </v-col>
                        <v-col cols="12">
                          <v-img
                            aspect-ratio="6"
                            contain
                            :src="formAdd.pictureUrlPreview"
                            :rules="[rules.required]"
                          ></v-img>
                          <v-file-input
                            outlined
                            dense
                            required
                            counter
                            show-size
                            :rules="[rules.required]"
                            accept="image/png, image/jpeg, image/bmp"
                            prepend-icon="mdi-camera"
                            label="Image"
                            @change="selectImg"
                            v-model="filesAdd"
                          ></v-file-input>
                          <v-text-field
                            v-model="formAdd.name"
                            label="ชื่อระดับสมาชิก"
                            placeholder="ชื่อระดับสมาชิก"
                            dense
                            outlined
                            required
                            :rules="[rules.required]"
                          ></v-text-field>
                          <VuetifyMoney
                            v-model="formAdd.point"
                            label="ต้องมีคะแนนเท่าไหร่ถึงจะได้ระดับนี้"
                            dense
                            outlined
                            required
                            :rules="[rules.required]"
                            v-bind:options="options2"
                          />
                          <VuetifyMoney
                            v-if="$session.getAll().data.shopId == shopNameData.SHOP_ID_CHUBB"
                            v-model="formAdd.pointPersen"
                            label="เพิ่มคะแนนเป็นเปอร์เซ็นต์"
                            dense
                            outlined
                            required
                            :rules="[rules.required]"
                            v-bind:options="options2"
                          />
                          <v-textarea
                            v-model="formAdd.priviledge"
                            :rules="[rules.required]"
                            outlined
                            name="input-7-4"
                            label="สิทธิประโยชน์"
                            row="1"
                            counter
                          ></v-textarea>
                          <v-textarea
                            v-model="formAdd.priviledgeEng"
                            outlined
                            name="input-7-4"
                            label="สิทธิประโยชน์ภาษาอังกฤษ"
                            row="1"
                            counter
                          ></v-textarea>
                        </v-col>
                        <v-row>
                          <v-spacer></v-spacer>
                          <v-col cols="6" class="d-flex justify-center">
                            <v-color-picker
                              :hide-canvas="!canvas"
                              hide-mode-switch
                              mode="hexa"
                              v-model="formAdd.color"
                              class="ma-2"
                            ></v-color-picker>
                          </v-col>
                          <v-spacer></v-spacer>
                        </v-row>
                        <v-col id="margin">
                          <v-row justify="center" id="v-step-1">
                            <v-btn
                              elevation="2"
                              x-large
                              color="#173053"
                              style="color: white !important"
                              :disabled="!validAdd"
                              :loading="loadingAdd"
                              @click="addData()"
                            >
                              <v-icon left>mdi-checkbox-marked-circle</v-icon>
                              บันทึก
                            </v-btn>
                          </v-row>
                        </v-col>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-form>
            </v-card>
          </v-dialog>
          <!-- end add -->

          <!-- edit -->
          <v-dialog v-model="dialogEdit" persistent :max-width= "resCol === '12' ? '' : '40%'" :fullscreen="resCol === '12' ? true : false">
            <v-card class="text-center">
              <v-form ref="form_update" v-model="validUpdate" lazy-validation>
                <v-card-text>
                  <v-container>
                    <v-col class="text-right">
                      <v-btn
                        small
                        color="#E0E0E0"
                        @click=";(dialogEdit = false), clearDataUpdate()"
                      >
                        <v-icon color="#173053">mdi-close</v-icon>
                      </v-btn>
                    </v-col>
                    <v-row justify="center">
                      <v-col style="padding: 15px 16px 0px; text-align:left;">
                        <h2>แก้ไขข้อมูลระดับสมาชิก</h2>
                      </v-col>
                      <!-- <v-col cols="10" class="text-center">
                        <v-img
                          class="v_text_edit"
                          :src="require('@/assets/GroupEditTitle.svg')"
                        ></v-img>
                      </v-col> -->
                    </v-row>
                    <v-row justify="center">
                      <v-col cols="10" class="text-center">
                        <v-img
                          aspect-ratio="6"
                          contain
                          :src="formUpdate.pictureUrlPreview"
                        ></v-img>
                        <!-- <v-avatar size="100px"><img alt="Avatar" :src="formAdd.pictureUrl"></v-avatar> -->
                        <br />
                        <v-file-input
                          required
                          outlined
                          counter
                          show-size
                          accept="image/png, image/jpeg, image/bmp"
                          prepend-icon="mdi-camera"
                          label="Image"
                          @change="selectImgUpdate"
                          v-model="filesUpdate"
                        ></v-file-input>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="10" class="ml-8">
                        <!-- <v-row style="height: 15px">
                          <v-subheader id="subtext"
                            >ชื่อระดับสมาชิก</v-subheader
                          >
                        </v-row> -->
                        <v-row style="height: 70px">
                          <v-text-field
                            v-model="formUpdate.name"
                            placeholder="ชื่อระดับสมาชิก"
                            label="ชื่อระดับสมาชิก"
                            outlined
                            dense
                            required
                            :rules="[rules.required]"
                          ></v-text-field>
                        </v-row>
                      </v-col>
                      <v-col cols="12" class="ml-8">
                        <!-- <v-row style="height: 15px">
                          <v-subheader id="subtext"
                            >ต้องมีคะแนนเท่าไหร่ ถึงจะได้ระดับนี้</v-subheader
                          >
                        </v-row> -->
                        <v-row style="height: 140px">
                          <VuetifyMoney
                            v-model="formUpdate.point"
                            label="ต้องมีคะแนนเท่าไหร่ถึงจะได้ระดับนี้"
                            dense
                            outlined
                            required
                            :rules="[rules.required]"
                            v-bind:options="options2"
                          />
                          <div style="width: 10px;"></div>
                        <VuetifyMoney
                            v-if="$session.getAll().data.shopId == shopNameData.SHOP_ID_CHUBB"
                            v-model="formUpdate.pointPersen"
                            label="เพิ่มคะแนนเป็นเปอร์เซ็นต์"
                            dense
                            outlined
                            required
                            :rules="[rules.required]"
                            v-bind:options="options2"
                          />
                        </v-row>
                      </v-col>
                    </v-row>
                    <v-col cols="12">
                      <!-- <v-row style="height: 35px" class="ml-1">
                        <v-subheader id="subtext">สิทธิประโยชน์</v-subheader>
                      </v-row> -->
                      <v-row class="ml-2">
                        <v-textarea
                          v-model="formUpdate.priviledge"
                          :rules="[rules.required]"
                          outlined
                          name="input-7-4"
                          label="สิทธิประโยชน์"
                          row="1"
                          counter
                        ></v-textarea>
                        <v-textarea
                          v-model="formUpdate.priviledgeEng"
                          outlined
                          name="input-7-4"
                          label="สิทธิประโยชน์ภาษาอังกฤษ"
                          row="1"
                          counter
                        ></v-textarea>
                        <!-- <v-textarea
                          auto-grow
                          outlined
                          rows="2"
                          name="input-7-4"
                          placeholder="Priviledge"
                          counter
                          dense
                          required
                          :rules="[rules.required]"
                          v-model="formUpdate.priviledge"
                        ></v-textarea> -->
                      </v-row>
                    </v-col>

                    <v-row>
                      <v-spacer></v-spacer>
                      <v-col cols="6">
                        <v-color-picker
                          :hide-canvas="!canvas"
                          hide-mode-switch
                          mode="hexa"
                          v-model="formUpdate.color"
                        ></v-color-picker>
                      </v-col>
                      <v-spacer></v-spacer>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-form>
              <v-card-actions id="v-step-3">
                <v-col id="margin">
                  <v-row justify="center">
                    <v-btn
                      elevation="2"
                      x-large
                      dark
                      color="#173053"
                      :disabled="!validUpdate"
                      :loading="loadingEdit"
                      @click="editData()"
                    >
                      <v-icon left>mdi-checkbox-marked-circle</v-icon>
                      บันทึก
                    </v-btn>
                  </v-row>
                </v-col>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end edit -->

          <!-- delete -->
          <v-dialog v-model="dialogDelete" persistent max-width="80%">
            <v-card>
              <v-card-title>
                <span class="headline">ลบข้อมูลนี้</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        label="รหัส Card*"
                        v-model="formUpdate.levelId"
                        readonly
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  elevation="2"
                  x-large
                  dark
                  class="btn-color"
                  @click="dialogDelete = false"
                >
                  <v-icon left> mdi-cancel</v-icon>
                  ปิด
                </v-btn>
                <v-btn
                  elevation="2"
                  x-large
                  dark
                  color="red darken-1"
                  @click="deleteData(item)"
                >
                  <v-icon left>mdi-checkbox-marked-circle</v-icon>
                  ลบ
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end delete -->

          <!-- data table -->
          <v-col cols="12">
            <!-- <v-card
              class="mx-auto card-index"
              width="400"
              height="200"
              color="#EF5350"
            >
              <div style="background-color:gray" class="rotate">sdsd</div>
              {{name}}
            </v-card>
            <br /><br /><br /> -->
            <v-card elevation="3" v-if="dataReady" style="border-radius: 7px;">
              <v-card-title>
                <v-text-field
                  v-model="searchAll2"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
              <v-card-text>
                <v-data-table
                  :headers="columns"
                  :items="Item"
                  :search="searchAll2"
                  :items-per-page="10"
                >
                  <template v-slot:[`item.point`]="{ item }">
                    {{ formatNumber(item.point) }}
                  </template>
                  <template v-slot:[`item.LAST_DATE`]="{ item }">
                    {{ thaiFormattedDate(item.LAST_DATE) }}
                  </template>
                  <template v-slot:[`item.CREATE_DATE`]="{ item }">
                    {{ thaiFormattedDate(item.CREATE_DATE) }}
                  </template>
                  <template v-if="priviledge" v-slot:[`item.priviledge`]="{ item }">
                    <nl2br tag="p" :text="item.priviledge" />
                  </template>
                  <template v-slot:[`item.color`]="{ item }">
                    <v-card
                      class="mx-auto card-index div_color"
                      width="120"
                      height="70"
                      color="#E0E0E0"
                    >
                      <div
                        :style="'background-color:' + item.color"
                        class="rotate"
                      ></div>
                    </v-card>
                  </template>
                  <template v-slot:[`item.action`]="{ item }">
                    <!-- <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          class="btn-color"
                          fab
                          id="v-step-2"
                          x-small
                          color="green"
                          @click.stop="getDataById(item, 'editReward')"
                        >
                          <v-icon color="white"> mdi-gift </v-icon>
                        </v-btn>
                      </template>
                      <span>เพิ่มของรางวัลตามระดับสมาชิก</span>
                    </v-tooltip> -->
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          class="btn-color"
                          fab
                          dark
                          id="v-step-2"
                          x-small
                          @click.stop="getDataById(item, 'edit')"
                        >
                          <v-icon dark> mdi-tools </v-icon>
                        </v-btn>
                      </template>
                      <span>แก้ไขข้อมูล</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          color="red"
                          dark
                          fab
                          x-small
                          @click.stop="deleteData(item)"
                        >
                          <v-icon> mdi-delete </v-icon>
                        </v-btn>
                      </template>
                      <span>ลบข้อมูล</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
            <div v-if="!dataReady" class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
          </v-col>
          <!-- end data table -->
        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import adminLeftMenu from '../Sidebar.vue' // เมนู
import VuetifyMoney from '../VuetifyMoney.vue'
import Nl2br from 'vue-nl2br'
// import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
// import XLSX from 'xlsx' // import xlsx
// import readXlsxFile from 'read-excel-file'
// import moment from 'moment' // แปลง date

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    VuetifyMoney,
    Nl2br
    // downloadExcel: JsonExcel,
    // XLSX,
    // readXlsxFile
  },
  computed: {
    resCol () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return '12'
        case 'sm':
          return '12'
        case 'md':
          return '6'
        case 'lg':
          return '6'
        case 'xl':
          return '6'
      }
      console.log(
        'this.$vuetify.breakpoint.name',
        this.$vuetify.breakpoint.name
      )
    }
  },
  created () {
    // setInterval(this.getNowGlobal, 1000)
  },
  data () {
    return {
      PK: '',
      returnLink: '/Master/Level',
      path: '/level/', // Path Model
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'Level',
          disabled: false,
          href: '/Master/Level'
        }
      ],
      options2: {
        locale: 'en-US',
        prefix: '',
        suffix: '',
        length: 9,
        precision: 0
      },
      // End Menu Config
      panelExplaneTion: true,
      dataReady: true,
      canvas: true,
      dateTime: '', // Generate DateTime
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      menu2: false,
      menu3: false,
      menu4: false,
      code: 'AGE_', // Generate Code
      // Dialog Config ADD EDIT DELETE IMPORT
      dialogAdd: false,
      dialogEdit: false,
      dialogDelete: false,
      dialogImport: false,
      dialogAddReward: false,
      // END Dialog Config ADD EDIT DELETE
      panel: [0],
      panel1: [1],
      dataFormAddReward: {
        name: '',
        subName: '',
        point: 0,
        pictureUrl: '',
        pictureUrlPreview: '',
        shopId: this.$session.getAll().data.shopId,
        levelNm: '',
        levelId: '',
        supply: 'levelUp'
      },
      session: this.$session.getAll(),
      // Search All
      searchAll: '',
      searchAll2: '',
      // Search Advanced
      search: {
        masAgeCode: '',
        masAgeName: '',
        create_date_start: '',
        create_date_end: '',
        last_date_start: '',
        last_date_end: ''
      },
      itemsDate: [{text: '1 เดือน', value: 30}, {text: '3 เดือน', value: 90}, {text: '6 เดือน', value: 180}, {text: '9 เดือน', value: 270}, {text: '1 ปี', value: 364}],
      color: '',
      formAdd: {
        name: '',
        point: 0,
        pointPersen: 0,
        priviledge: '',
        priviledgeEng: '',
        CREATE_USER: '',
        LAST_USER: '',
        shopId: this.$session.getAll().data.shopId,
        pictureUrl: '',
        pictureUrlPreview: '',
        color: ''
      },
      formUpdate: {
        levelId: '',
        name: '',
        point: 0,
        pointPersen: 0,
        priviledge: '',
        priviledgeEng: '',
        LAST_USER: '',
        shopId: '',
        pictureUrl: '',
        pictureUrlPreview: '',
        color: ''
      },
      rules: {
        numberRules: value =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        counterTel: value => value.length <= 10 || 'Max 10 characters',
        IDcardRules: value =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        required: value => !!value || 'กรุณากรอก.',
        counterIDcard: value => value.length <= 13 || 'Max 13 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      },
      // End Form Config ADD EDIT
      // Data Table Config
      columns: [
        { text: 'ระดับ', value: 'name' },
        { text: 'คะแนน', value: 'point' },
        { text: 'สิทธิ์ที่ได้รับ', value: 'priviledge' },
        { text: 'สีของระดับ', value: 'color', align: 'center' },
        { text: 'วันที่สร้าง', value: 'CREATE_DATE' },
        { text: 'จัดการ', value: 'action', sortable: false, align: 'center' }
      ],
      Item: [],
      validAdd: true,
      validUpdate: true,
      filesAdd: null,
      filesUpdate: null,
      // End Data Table Config
      //   loading
      loadingAdd: false,
      loadingEdit: false
    }
  },
  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/Core/Login')
    }
  },
  async mounted () {
    // this.getGetToken(this.DNS_IP)
    this.dataReady = false
    this.getDataLevel()
    this.getRewardByLevel()
    // Get Data
    // await this.getDataGlobal(
    //   this.DNS_IP,
    //   this.path,
    //   this.session.data.shopId,
    //   this.returnLink
    // )
    if (this.$route.query.tour) {
      if (this.$route.query.tour === 'true') {
        this.$tours['myTour'].start()
      } else {
        this.$tours['myTourPage'].start()
      }
    }
  },
  methods: {
    addReward () {
      console.log('dataFormAddReward', this.dataFormAddReward)
    },
    chooseImage () {
      this.$refs.fileInput.click()
    },
    onSelectFile () {
      const input = this.$refs.fileInput
      this.filesAdd = input.files
      if (this.filesAdd) {
        this.dataFormAddReward.pictureUrlPreview = URL.createObjectURL(this.filesAdd[0])
      } else {
        this.dataFormAddReward.pictureUrlPreview = ''
      }
      this.$forceUpdate()
      console.log('kkkk', this.dataFormAddReward.pictureUrlPreview)
    },
    getRewardByLevel () {
      axios
        .get(this.DNS_IP + '/level/get?shopId=' + this.session.data.shopId)
        .then(res => {
          this.ItemReward = res.data
          this.dataReady = true
        })
    },
    getDataLevel () {
      axios
        .get(this.DNS_IP + '/level/get?shopId=' + this.session.data.shopId)
        .then(res => {
          this.Item = res.data
          this.dataReady = true
        })
    },
    selectImgUpdate (event) {
      if (this.filesUpdate != null) {
        this.formUpdate.pictureUrlPreview = URL.createObjectURL(
          this.filesUpdate
        )
      } else {
        this.formUpdate.pictureUrlPreview = ''
      }
      // console.log(event)
    },
    selectImg (event) {
      if (this.filesAdd) {
        this.formAdd.pictureUrlPreview = URL.createObjectURL(this.filesAdd)
      } else {
        this.formAdd.pictureUrlPreview = ''
      }
      // console.log(event)
    },
    validate (Action) {
      switch (Action) {
        case 'ADD':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_add.validate()
          })
          break
        case 'UPDATE':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_update.validate()
          })
          break

        default:
          break
      }
    },
    async searchDataAll () {
      //
      //
      // สำหรับ ค้นหาแบบ LIKE Search
      // ต้องระบุ Field ที่จะส่งไปให้ตรงกับ Model
      //
      var search =
        '?levelId=' +
        this.searchAll +
        '&name=' +
        this.searchAll +
        '&Point=' +
        this.searchAll +
        '&priviledge=' +
        this.searchAll
      this.dataReady = false
      this.searchDataAllGlobal(this.DNS_IP, this.path, search, this.returnLink)
    },
    async getDataById (item, type) {
      //
      //
      // สำหรับ เรียกข้อมูล ใส่ form Update / Delete
      //
      //
      // Get ID /main.js
      this.dataReady = false
      await this.getDataByIdGlobal(
        this.DNS_IP,
        this.path,
        'levelId',
        item.levelId,
        this.returnLink
      )
      this.formUpdate.pictureUrlPreview = this.formUpdate.pictureUrl
      if (type === 'edit') {
        this.dialogEdit = true
        this.validate('UPDATE')
      } else if (type === 'delete') {
        this.dialogDelete = true
      } else if (type === 'editReward') {
        this.dialogAddReward = true
      }
    },
    async addData () {
      this.dataReady = false

      this.$swal({
        title: 'ต้องการ เพิ่มข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async result => {
          this.loadingAdd = true
          this.formAdd.CREATE_USER = this.session.data.userName
          this.formAdd.LAST_USER = this.session.data.userName
          if (this.formAdd.point === '') {
            this.formAdd.point = 0
          }
          if (this.formAdd.pointPersen === '') {
            this.formAdd.pointPersen = 0
          }
          const _this = this
          let params = new FormData()
          params.append('file', this.filesAdd)

          await axios
            .post(this.DNS_IP + `/file/upload/reward`, params)
            .then(function (response) {
              _this.formAdd.pictureUrl = response.data
              console.log('url Pic', response.data)
            })
          delete this.formAdd['pictureUrlPreview']
          await axios
            .post(
              this.DNS_IP + this.path + 'add',
              this.formAdd
            )
            .then(async response => {
              this.dialogAdd = false

              // Load Data
              await this.clearDataAdd()
              this.dataReady = true
              this.getDataLevel()

              // await this.getDataGlobal(
              //   this.DNS_IP,
              //   this.path,
              //   this.session.data.shopId,
              //   this.returnLink
              // )
              this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
              this.loadingAdd = false
            })
            // eslint-disable-next-line handle-callback-err
            .catch(error => {
              console.log('error function addDataGlobal : ', error)
              this.$router.push(
                '/system/Errorpage?returnLink=' + this.returnLink
              )
              this.dataReady = true
            })
        })
        .catch(error => {
          console.log('error function addData : ', error)
          this.dataReady = true
        })
    },
    async editData () {
      this.dataReady = false

      this.$swal({
        title: 'ต้องการ แก้ไขข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async result => {
          this.loadingEdit = true
          this.formUpdate.LAST_USER = this.session.data.userName
          var ID = this.formUpdate.levelId
          if (this.filesUpdate) {
            const _this = this
            let params = new FormData()
            params.append('file', this.filesUpdate)

            await axios
              .post(this.DNS_IP + `/file/upload/reward`, params)
              .then(function (response) {
                _this.formUpdate.pictureUrl = response.data
                console.log('url Pic', response.data)
              })
          } else {
            this.formUpdate.pictureUrl = this.formUpdate.pictureUrlPreview
          }
          delete this.formUpdate['pictureUrlPreview']
          delete this.formUpdate['levelId']
          delete this.formUpdate['LAST_DATE']
          delete this.formUpdate['CREATE_DATE']
          if (this.formUpdate.point === '') {
            this.formUpdate.point = 0
          }
          if (this.formUpdate.pointPersen === '') {
            this.formUpdate.pointPersen = 0
          }
          await axios
            .post(
              this.DNS_IP + this.path + 'edit/' + ID,
              this.formUpdate
            )
            .then(async response => {
              // Debug response
              console.log('editDataGlobal DNS_IP + PATH + "edit"', response)
              this.dialogEdit = false
              this.clearDataUpdate()
              this.$swal('เรียบร้อย', 'แก้ไขข้อมูล เรียบร้อย', 'success')
              this.loadingEdit = false
              this.getDataLevel()
              this.dataReady = true
            })
            // eslint-disable-next-line handle-callback-err
            .catch(error => {
              this.dataReady = true
              console.log('error function editDataGlobal : ', error)
              this.$router.push(
                '/system/Errorpage?returnLink=' + this.returnLink
              )
            })
        })
        .catch(error => {
          this.dataReady = true
          console.log('error function editDataGlobal : ', error)
        })
    },
    async deleteData (item) {
      console.log('aaa', item)
      if (this.Item.length === 1) {
        this.$swal('ผิดพลาด', 'ไม่สามารถลบข้อมูลได้ *จำเป็นต้องมีข้อมูลระดับสมาชิกอย่างน้อย 1 ระดับ', 'error')
      } else {
        this.formUpdate.LAST_USER = this.session.data.userName
        this.dataReady = false
        this.$swal({
          title: 'ลบข้อมูล',
          text: 'คุณต้องการลบ ' + item.name + ' ใช่หรือไม่',
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#1B437C',
          cancelButtonColor: '#f22731',
          confirmButtonText: 'ยืนยัน',
          cancelButtonText: 'ยกเลิก'
        })
          .then(async result => {
            await axios
              .post(this.DNS_IP + '/level/delete/' + item.levelId, this.formUpdate)
              .then(async response => {
                this.$swal('เรียบร้อย', 'ลบข้อมูลเรียบร้อย', 'success')
                this.dialogDelete = false
                this.getDataLevel()
              })
          })
      }
    },
    async clearDataAdd () {
      this.formAdd.name = ''
      this.formAdd.point = 0
      this.formAdd.pointPersen = 0
      this.formAdd.priviledge = ''
      this.formAdd.priviledgeEng = ''
      this.formAdd.CREATE_USER = ''
      this.formAdd.LAST_USER = ''
      this.formAdd.shopId = this.$session.getAll().data.shopId
      this.formAdd.pictureUrl = ''
      this.formAdd.pictureUrlPreview = ''
      this.filesAdd = null
      this.formAdd.color = ''
    },
    async clearDataUpdate () {
      this.formUpdate.levelId = ''
      this.formUpdate.name = ''
      this.formUpdate.point = 0
      this.formUpdate.pointPersen = 0
      this.formUpdate.priviledge = ''
      this.formUpdate.priviledgeEng = ''
      this.formUpdate.LAST_USER = ''
      this.formUpdate.shopId = ''
      this.formUpdate.pictureUrl = ''
      this.formUpdate.pictureUrlPreview = ''
      this.filesUpdate = null
      this.formUpdate.color = ''
    }
  }
}
</script>
<style scope>
.v-tour__target--highlighted {
  box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.4);
}
#margin {
  margin-top: 50px;
  margin-bottom: 40px;
}
.v_text_edit {
  width: 255px;
  height: 52px;
}
.div_color {
  width: 5rem;
  height: 2.5rem;
  display: block;
  border-radius: 11px;
}
.card-index {
  overflow: hidden;
  position: relative;
}
.rotate {
  width: 10px;
  height: 150px;
  position: absolute;
  top: -50px;
  transform: rotate(30deg);
  -webkit-transform: rotate(45deg);
}
/* .placeholder {
  background: #f0f0f0;
  width: 100%;
  height: 133px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #333;
  font-size: 18px;
  border-radius: 15px;
} */
.image-input {
  display: block;
  width: 250px;
  height: 153px;
  cursor: pointer;
  background-size: cover;
  background-position: center center;
  text-align: center;
  border-radius: 20px !important;
}
.image-input2 {
  display: block;
  width: 250px;
  height: 153px;
  cursor: pointer;
  background-size: cover;
  background-position: center center;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 20px !important;
}
.hoverDelete:hover{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Master/Level.vue